import Vue from 'vue'
import Router from 'vue-router'
 
import MobileHelloWorld from '@/pages/mobile/MobileHelloWorld.vue'
import BaoCan from '@/pages/mobile/BaoCan.vue'
import SaoMa from '@/pages/mobile/SaoMa.vue'
import WoDe from '@/pages/mobile/WoDe.vue'
import WangZhanInfo from '@/pages/WangZhanInfo'
import YongHu from '@/pages/YongHu'
import GuanLi from '@/pages/GuanLi'
import GuiZe from '@/pages/GuiZe'
import HelloWorld from '@/components/HelloWorld.vue'
import BuMen from '@/pages/BuMen.vue'
import CaiDan from '@/pages/CaiDan.vue'
import DingDan from '@/pages/DingDan.vue'
import TongJi from '@/pages/TongJi.vue'
import KaiCan from '@/pages/KaiCan.vue'
import HeXiao from '@/pages/HeXiao.vue'
import BaoCanRecord from '@/pages/mobile/BaoCanRecord.vue'
import YuerRecord from '@/pages/mobile/YuerRecord.vue'



Vue.use(Router)
 
// 桌面端路由规则
const pcRoutes = [
  {
    path: '/',
    component: HelloWorld,
    children: [
      { path: '/WangZhanInfo', component: WangZhanInfo, meta: { title: '网站信息' } },
      { path: '/YongHu', component: YongHu, meta: { title: '用户组' } },
      { path: '/GuanLi', component: GuanLi, meta: { title: '管理组' } },
      { path: '/GuiZe', component: GuiZe, meta: { title: '规则管理' } },
      { path: '/BuMen', component: BuMen, meta: { title: '部门管理' } },
      { path: '/CaiDan', component: CaiDan, meta: { title: '本周菜单' } },
      { path: '/DingDan', component: DingDan, meta: { title: '订单管理' } },
      { path: '/TongJi', component: TongJi, meta: { title: '统计管理' } },
      { path: '/KaiCan', component: KaiCan, meta: { title: '开餐二维码' } },
      { path: '/HeXiao', component: HeXiao, meta: { title: '核销记录' } },
    ]
  }
          
    
];

//移动端路由规则
const mobileRoutes = [
  {
    path:'/',
    redirect: '/baocan', 
    component:MobileHelloWorld,
    children:[
      {
        path: "/baocan",
        name: "baocan",
        component: BaoCan,
        meta:{title:"报餐"}
      },
      {
        path: "/saoma", // 新添加的路径
        name: "saoma", // 新添加的名称
        component: SaoMa, // 新添加的组件
        meta: { title: "扫码" } // 新添加的标题
      },
      {
        path: "/wode", // 新添加的路径
        name: "wode", // 新添加的名称
        component: WoDe, // 新添加的组件
        meta: { title: "我的" } // 新添加的标题
      },
    ]
    
  },
  {
    path: '/baocanRecord',
    name: 'BaoCanRecord',
    component: BaoCanRecord
  },
  {
    path: '/yuerRecord',
    name: 'YuerRecord',
    component: YuerRecord
  }
]
// 判断设备类型
function isMobile() {
  return window.innerWidth < 768;
}

// 根据设备类型动态选择路由
const routes = isMobile() ? mobileRoutes : pcRoutes;

const router = new Router({
  mode: 'hash',
  routes
});


export default router;